// src/modules/doctor/index.js
import React, { Component } from 'react';
import '../../styles/doctor.css';
import { API_ENDPOINTS, postRequest,getRequest } from '../../config/apiConfig';

/* ── SVG Icons ──────────────────────────────────────────────── */
const ICONS = {
  heartbeat:  'M22 12h-4l-3 9L9 3l-3 9H2',
  home:       'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10',
  calendar:   'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z',
  pill:       'M10.5 20H4a2 2 0 01-2-2V6a2 2 0 012-2h7M20 8V4a2 2 0 00-2-2h-2.5M14 12l-3 3M17 9l-3 3M21 15a6 6 0 11-8.485 8.485',
  menu:       'M3 12h18M3 6h18M3 18h18',
  bell:       'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0',
  logout:     'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
  check:      'M20 6L9 17l-5-5',
  users:      'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M9 11a4 4 0 100-8 4 4 0 000 8z',
  user:       'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z',
  edit:       'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z',
  chevronR:   'M9 18l6-6-6-6',
  alert:      'M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
  info:       'M12 22a10 10 0 100-20 10 10 0 000 20zM12 8h.01M11 12h1v4h1',
  trash:      'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6',
  plus:       'M12 5v14M5 12h14',
  qr:         'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM20 14v3M17 20h3M20 20v1',
  search:     'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z',
  refresh:    'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15',
};

class Ico extends Component {
  render() {
    const { name, size = 18, color = 'currentColor', className = '' } = this.props;
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={className} style={{ flexShrink: 0 }}>
        <path d={ICONS[name] || ICONS.info} />
      </svg>
    );
  }
}

/* ── QuillEditor ── */
function loadQuill() {
  return new Promise(resolve => {
    if (window.Quill) { resolve(); return; }
    if (!document.getElementById('quill-css')) {
      const link = document.createElement('link');
      link.id = 'quill-css'; link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.min.css';
      document.head.appendChild(link);
    }
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.min.js';
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
}

class QuillEditor extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.quill = null;
    this.state = { loading: true };
  }
  async componentDidMount() {
    await loadQuill();
    this.setState({ loading: false }, () => this.initQuill());
  }
  initQuill() {
    if (!this.containerRef.current || this.quill) return;
    const { accentColor = '#0A6EFF' } = this.props;
    const styleId = `quill-style-${Math.random().toString(36).slice(2)}`;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .ql-toolbar.ql-snow { border-color:#E2E8F0!important;border-radius:10px 10px 0 0;background:#F7F9FC;padding:8px 10px; }
      .ql-container.ql-snow { border-color:#E2E8F0!important;border-radius:0 0 10px 10px;font-family:'Plus Jakarta Sans',sans-serif;font-size:13px; }
      .ql-editor { min-height:140px;line-height:1.8;padding:12px 14px; }
      .ql-editor.ql-blank::before { color:#94A3B8;font-style:normal; }
      .ql-toolbar button:hover .ql-stroke,.ql-toolbar button.ql-active .ql-stroke { stroke:${accentColor}!important; }
      .ql-toolbar button:hover .ql-fill,.ql-toolbar button.ql-active .ql-fill { fill:${accentColor}!important; }
    `;
    document.head.appendChild(style);
    this._styleId = styleId;
    this.quill = new window.Quill(this.containerRef.current, {
      theme: 'snow',
      placeholder: this.props.placeholder || 'Type here…',
      modules: { toolbar: [[{ header:[1,2,3,false] }],['bold','italic','underline','strike'],[{list:'ordered'},{list:'bullet'}],[{indent:'-1'},{indent:'+1'}],['clean']] },
    });
    if (this.props.value) this.quill.root.innerHTML = this.props.value;

    // ── Special character filter: allow only letters, digits, whitespace, - and / ──
    this.quill.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        const text = this.quill.getText();
        // Allow: a-z, A-Z, 0-9, whitespace, newlines, Devanagari (\u0900-\u097F), - and /
        const hasDisallowed = /[^a-zA-Z0-9\s\n\r\u0900-\u097F\-\/]/.test(text);
        if (hasDisallowed) {
          const sel = this.quill.getSelection();
          const contents = this.quill.getContents();
          contents.ops = contents.ops.map(op => {
            if (typeof op.insert === 'string') {
              op.insert = op.insert.replace(/[^a-zA-Z0-9\s\n\r\u0900-\u097F\-\/]/g, '');
            }
            return op;
          });
          this.quill.setContents(contents, 'silent');
          if (sel) {
            const newLen = this.quill.getLength();
            this.quill.setSelection(Math.min(sel.index, newLen - 1), 0, 'silent');
          }
        }
      }
      const html = this.quill.root.innerHTML;
      if (this.props.onChange) this.props.onChange(html === '<p><br></p>' ? '' : html);
    });
  }
  componentDidUpdate(prevProps) {
    if (!this.quill) return;
    const newVal = this.props.value || '', oldVal = prevProps.value || '';
    if (newVal !== oldVal && newVal) {
      const cur = this.quill.root.innerHTML;
      if (!cur || cur === '<p><br></p>') {
        this.quill.root.innerHTML = newVal;
        this.quill.setSelection(this.quill.getLength(), 0);
      }
    }
  }
  componentWillUnmount() {
    const el = this._styleId ? document.getElementById(this._styleId) : null;
    if (el) el.remove();
  }
  render() {
    return (
      <div style={{ borderRadius:10, overflow:'hidden', border:'1.5px solid #E2E8F0' }}>
        {this.state.loading && <div style={{ padding:'32px 16px', textAlign:'center', color:'#94A3B8', fontSize:13 }}>Loading editor…</div>}
        <div ref={this.containerRef} style={{ display: this.state.loading ? 'none' : 'block' }} />
      </div>
    );
  }
}

/* ── Mode Toggle (Manual / Auto) ── */
function ModeToggle({ mode, onChange }) {
  const btn = (val, label, emoji) => (
    <button onClick={() => onChange(val)} style={{
      flex:1, padding:'8px 0', borderRadius:8, border:'none', cursor:'pointer',
      fontFamily:'inherit', fontSize:13, fontWeight:700, transition:'all .15s',
      background: mode===val ? '#0A6EFF' : 'transparent',
      color:      mode===val ? '#fff'    : '#6b748c',
    }}>
      {emoji} {label}
    </button>
  );
  return (
    <div style={{ display:'flex', gap:4, background:'#F1F5F9', borderRadius:10, padding:4, marginBottom:14 }}>
      {btn('manual',   'Manual',     '✏️')}
      {btn('auto',     'Auto Select','⚡')}
    </div>
  );
}

/* ── Multi-select dropdown for Auto mode ── */
const MEDICINE_OPTIONS = [
  'Paracetamol 500mg — Twice daily — After food — 5 days',
  'Paracetamol 650mg — Thrice daily — After food — 3 days',
  'Amoxicillin 250mg — Thrice daily — With food — 7 days',
  'Amoxicillin 500mg — Twice daily — With food — 5 days',
  'Ibuprofen 400mg — Twice daily — After food — 5 days',
  'Cetirizine 10mg — Once daily — At night — 5 days',
  'Pantoprazole 40mg — Once daily — Before breakfast — 14 days',
  'Metformin 500mg — Twice daily — With food — 30 days',
  'Atorvastatin 10mg — Once daily — At night — 30 days',
  'Azithromycin 500mg — Once daily — Empty stomach — 3 days',
  'Dolo 650 — Thrice daily — After food — 5 days',
  'Crocin 500mg — As needed — After food',
  'Omeprazole 20mg — Once daily — Before breakfast — 14 days',
  'Vitamin D3 60000 IU — Once weekly — With food — 8 weeks',
  'Vitamin B12 500mcg — Once daily — After food — 30 days',
  'Calcium + Vitamin D — Once daily — After food — 30 days',
  'Montair LC — Once daily — At night — 10 days',
  'Allegra 120mg — Once daily — After food — 5 days',
  'Norflox 400mg — Twice daily — Empty stomach — 5 days',
  'Metronidazole 400mg — Thrice daily — After food — 5 days',
];

const LAB_OPTIONS = [
  'CBC (Complete Blood Count) — Haematology — Blood sample',
  'Blood Sugar Fasting — Biochemistry — Fasting required',
  'Blood Sugar PP — Biochemistry — 2 hrs after meal',
  'HbA1c — Biochemistry — Blood sample',
  'Lipid Profile — Biochemistry — Fasting required',
  'LFT (Liver Function Test) — Biochemistry — Blood sample',
  'KFT (Kidney Function Test) — Biochemistry — Blood sample',
  'Thyroid Profile (TSH/T3/T4) — Biochemistry — Blood sample',
  'Urine Routine — Microbiology — Urine sample',
  'Urine Culture — Microbiology — Mid-stream urine',
  'ECG — Cardiology — No preparation',
  'Chest X-Ray — Radiology — No preparation',
  'USG Abdomen — Radiology — Full bladder required',
  '2D Echo — Cardiology — No preparation',
  'Dengue NS1 — Serology — Blood sample',
  'Malaria Antigen — Serology — Blood sample',
  'COVID RT-PCR — Virology — Nasal swab',
  'Stool Routine — Microbiology — Stool sample',
  'Serum Creatinine — Biochemistry — Blood sample',
  'Vitamin D (25-OH) — Biochemistry — Blood sample',
  'Iron Studies — Biochemistry — Blood sample',
  'PT/INR — Haematology — Blood sample',
];

class AutoSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { search: '', open: false };
    this.wrapRef = React.createRef();
  }
  componentDidMount()    { document.addEventListener('mousedown', this.handleOutside); }
  componentWillUnmount() { document.removeEventListener('mousedown', this.handleOutside); }
  handleOutside = e => { if (this.wrapRef.current && !this.wrapRef.current.contains(e.target)) this.setState({ open: false }); }

  toggle(item) {
    const { selected, onChange } = this.props;
    const already = selected.includes(item);
    onChange(already ? selected.filter(s => s !== item) : [...selected, item]);
  }

  render() {
    const { selected, options, placeholder } = this.props;
    const { search, open } = this.state;
    const filtered = options.filter(o => o.toLowerCase().includes(search.toLowerCase()));

    return (
      <div ref={this.wrapRef} style={{ position:'relative' }}>
        {/* Selected tags */}
        {selected.length > 0 && (
          <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:8 }}>
            {selected.map(s => (
              <div key={s} style={{ display:'flex', alignItems:'center', gap:5, background:'#E8F1FF', color:'#0A6EFF', borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:600 }}>
                <span style={{ maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.split(' — ')[0]}</span>
                <button onClick={() => this.toggle(s)} style={{ border:'none', background:'none', cursor:'pointer', color:'#0A6EFF', padding:0, fontSize:14, lineHeight:1, fontWeight:700 }}>×</button>
              </div>
            ))}
          </div>
        )}

        {/* Search input */}
        <div style={{ position:'relative' }}>
          <input
            value={search}
            onChange={e => this.setState({ search: e.target.value, open: true })}
            onFocus={() => this.setState({ open: true })}
            placeholder={placeholder || 'Search and select…'}
            style={{ width:'100%', height:42, padding:'0 14px', border:'1.5px solid #E2E8F0', borderRadius:10, fontSize:13, fontFamily:'inherit', outline:'none', boxSizing:'border-box' }}
          />
          <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', color:'#94A3B8', fontSize:12 }}>
            {selected.length > 0 ? `${selected.length} selected` : '▾'}
          </div>
        </div>

        {/* Dropdown */}
        {open && (
          <div style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:100, background:'#fff', border:'1.5px solid #E2E8F0', borderRadius:12, boxShadow:'0 8px 32px rgba(0,0,0,.12)', maxHeight:260, overflowY:'auto', marginTop:4 }}>
            {filtered.length === 0 ? (
              <div style={{ padding:'16px', textAlign:'center', color:'#94A3B8', fontSize:13 }}>No results</div>
            ) : filtered.map(item => {
              const isSelected = selected.includes(item);
              const [name, ...rest] = item.split(' — ');
              return (
                <div key={item} onClick={() => this.toggle(item)}
                  style={{ padding:'10px 14px', cursor:'pointer', display:'flex', alignItems:'flex-start', gap:10, background: isSelected ? '#F0F6FF' : 'transparent', borderBottom:'1px solid #F1F5F9' }}>
                  <div style={{ width:18, height:18, borderRadius:5, border:`2px solid ${isSelected?'#0A6EFF':'#CBD5E1'}`, background:isSelected?'#0A6EFF':'transparent', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', marginTop:1 }}>
                    {isSelected && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>}
                  </div>
                  <div>
                    <div style={{ fontSize:13, fontWeight:600, color:'#0a0f1e' }}>{name}</div>
                    {rest.length > 0 && <div style={{ fontSize:11, color:'#6b748c', marginTop:2 }}>{rest.join(' — ')}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

/* ── Static fallback ── */
const APPOINTMENTS = [
  { id:'APT-2401', patient:'Raj Sharma', age:35, dept:'Cardiology', time:'10:00 AM', payStatus:'paid' },
  { id:'APT-2402', patient:'Priya Verma', age:28, dept:'Cardiology', time:'10:30 AM', payStatus:'pending' },
];

function StatusBadge({ status }) {
  const cls = status==='paid'?'dr-badge dr-badge-paid':status==='pending'?'dr-badge dr-badge-pending':'dr-badge dr-badge-offline';
  return <span className={cls}>{status}</span>;
}

/* ════════════════════════════════════════════════════════════
   SIDEBAR
════════════════════════════════════════════════════════════ */
class Sidebar extends Component {
  render() {
    const { activePage, onNav, isOpen, onClose, onLogout, doctorName } = this.props;
    const NAV = [
      { id:'appointments', label:'Appointments',       icon:'calendar' },
      { id:'prescribe',    label:'Write Prescription', icon:'pill'     },
      { id:'scan-qr',      label:'Scan QR',            icon:'qr'       },
    ];
    const initials = (doctorName||'DR').split(' ').filter(w=>/^[A-Z]/.test(w)).slice(0,2).map(w=>w[0]).join('');
    return (
      <>
        <div className={`dr-overlay${isOpen?' show':''}`} onClick={onClose} />
        <aside className={`dr-sidebar${isOpen?' open':''}`}>
          <div className="dr-sidebar-logo">
            <div className="dr-sidebar-logo-icon"><Ico name="heartbeat" size={18} color="#fff" /></div>
            <div><div className="dr-logo-name">DG Doctor</div><div className="dr-logo-sub">Hospital System</div></div>
          </div>
          <div className="dr-sidebar-user">
            <div className="dr-sidebar-avatar">{initials||'DR'}</div>
            <div><div className="dr-sidebar-uname">{doctorName||'Doctor'}</div><div className="dr-sidebar-urole">Doctor</div></div>
          </div>
          <nav className="dr-sidebar-nav">
            <div className="dr-nav-section">Menu</div>
            {NAV.map(item=>(
              <button key={item.id} className={`dr-nav-btn${activePage===item.id?' active':''}`} onClick={()=>{onNav(item.id);onClose();}}>
                <Ico name={item.icon} size={16} color={activePage===item.id?'var(--brand)':'var(--text-3)'} />
                {item.label}
                {activePage===item.id && <div className="dr-nav-dot" />}
              </button>
            ))}
          </nav>
          <button className="dr-sidebar-signout" onClick={onLogout}><Ico name="logout" size={15} /> Sign out</button>
        </aside>
      </>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   HEADER
════════════════════════════════════════════════════════════ */
class Header extends Component {
  render() {
    const { title, subtitle, onMenuClick } = this.props;
    return (
      <header className="dr-header">
        <button className="dr-header-menu" onClick={onMenuClick}><Ico name="menu" size={20} /></button>
        <div><div className="dr-header-title">{title}</div>{subtitle&&<div className="dr-header-sub">{subtitle}</div>}</div>
        <div className="dr-header-right">
          <div className="dr-header-bell"><Ico name="bell" size={17} color="var(--text-2)" /><div className="dr-header-bell-dot" /></div>
          <div className="dr-header-avatar">AU</div>
        </div>
      </header>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   DOCTOR DASHBOARD PAGE
════════════════════════════════════════════════════════════ */
class DoctorDashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = { appointments:[], loading:true, error:null, selectedAppt:null, lastUpdated:null, countdown:60 };
  }
  componentDidMount() {
    this.fetchAppointments();
    this._timer     = setInterval(()=>this.fetchAppointments(true), 60000);
    this._countdown = setInterval(()=>this.setState(s=>({countdown:s.countdown>0?s.countdown-1:60})), 1000);
  }
  componentWillUnmount() { clearInterval(this._timer); clearInterval(this._countdown); }
  async fetchAppointments(silent=false) {
    if (!silent) this.setState({loading:true,error:null});
    try {
      const u=JSON.parse(localStorage.getItem('dg_user')||'{}');
      const res=await postRequest(API_ENDPOINTS.DOCTOR_APPOINTMENTS,{DoctorID:u.personId||u.doctorId||null});
      const data=await res.json();
      let rows=[];
      if (data.status&&Array.isArray(data.data)&&Array.isArray(data.data[0])) rows=data.data[0];
      else if (Array.isArray(data.data)) rows=data.data;
      else if (Array.isArray(data)) rows=data;
      this.setState({appointments:rows,selectedAppt:rows[0]||null,lastUpdated:new Date(),countdown:60,loading:false});
    } catch(err) {
      this.setState({appointments:APPOINTMENTS,selectedAppt:APPOINTMENTS[0],loading:false,error:err.message});
    }
  }
  mapRow(a,i) {
    const fn=a.PatientFirstName||'',ln=a.PatientLastName||'';
    const name=`${fn} ${ln}`.trim()||a.patient||`Patient ${i+1}`;
    const dob=a.PatientDOB||a.DOB||'';
    const age=dob?Math.floor((Date.now()-new Date(dob).getTime())/(1000*60*60*24*365.25)):(a.age||'—');
    return {
      id:String(a.AppointmentID||a.id||`APT-${2400+i}`), patient:name, age,
      dept:a.DepartmentName||a.dept||'—', time:a.Time||a.AppointmentTime||a.time||'—',
      status:(a.PaymentStatus||a.payStatus||'pending').toLowerCase(),
      reason:a.Reason||a.ReasonForVisit||'—', gender:a.PatientGender||'—', blood:a.PatientBloodGroup||'—', spec:a.Specilization||'',
    };
  }
  render() {
    const {doctorName,onNav}=this.props;
    const {appointments,loading,error,selectedAppt,lastUpdated,countdown}=this.state;
    const today=new Date().toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'});
    const rows=appointments.map((a,i)=>this.mapRow(a,i));
    const paid=rows.filter(a=>a.status==='paid').length;
    const pending=rows.filter(a=>a.status==='pending').length;
    const dept=rows[0]?.dept||'—';
    let doctorCode='';
    try{const u=JSON.parse(localStorage.getItem('dg_user')||'{}');doctorCode=u.doctorCode||u.doctorId||'';}catch(e){}
    const selMapped=selectedAppt?this.mapRow(selectedAppt,0):null;
    const firstPaidAppt=selMapped?.status==='paid'?selectedAppt:appointments.find(a=>(a.PaymentStatus||a.payStatus||'').toLowerCase()==='paid')||null;
    const sel=firstPaidAppt?this.mapRow(firstPaidAppt,0):null;
    const fmtTime=d=>d?d.toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}):'—';
    const STATS=[
      {label:"Today's Patients",value:loading?'—':rows.length,icon:'users',color:'#0A6EFF',bg:'#E8F1FF'},
      {label:'Consultations Done',value:loading?'—':paid,icon:'check',color:'#00C896',bg:'#E6FAF5'},
      {label:'Prescriptions Written',value:loading?'—':paid,icon:'pill',color:'#7B5CF6',bg:'#F0EDFE'},
      {label:'Pending Patients',value:loading?'—':pending,icon:'bell',color:'#FF6B35',bg:'#FFF0EB'},
    ];
    return (
      <div>
        <div className="dr-page-header dr-fade-up" style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12,flexWrap:'wrap'}}>
          <div>
            <h1 className="dr-page-title">Doctor Dashboard</h1>
            <p className="dr-page-sub">{doctorName}{doctorCode?` · ${doctorCode}`:''} · {dept} · {today}</p>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:10,flexShrink:0}}>
            <div style={{fontSize:12,color:'var(--text-3)',textAlign:'right'}}>
              {lastUpdated&&<div>Updated {fmtTime(lastUpdated)}</div>}
              <div style={{color:'var(--brand)',fontWeight:600}}>Next refresh in {countdown}s</div>
            </div>
            <button onClick={()=>this.fetchAppointments()} style={{width:34,height:34,borderRadius:10,border:'1.5px solid var(--border)',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <Ico name="refresh" size={15} color="var(--brand)" />
            </button>
          </div>
        </div>
        <div className="dr-stats-grid">
          {STATS.map((s,i)=>(
            <div key={i} className={`dr-stat-card dr-fade-up-${i}`}>
              <div className="dr-stat-icon" style={{background:s.bg}}><Ico name={s.icon} size={20} color={s.color} /></div>
              <div><div className="dr-stat-label">{s.label}</div><div className="dr-stat-value">{s.value}</div></div>
            </div>
          ))}
        </div>
        {error&&!loading&&(
          <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:10,padding:'10px 14px',marginBottom:14,fontSize:13,color:'#FF6B35',display:'flex',gap:8}}>
            <Ico name="alert" size={14} color="#FF6B35" /> Could not load from API — showing fallback data.
            <button onClick={()=>this.fetchAppointments()} style={{marginLeft:'auto',border:'none',background:'transparent',color:'#FF6B35',fontWeight:700,cursor:'pointer',fontSize:12}}>↺ Retry</button>
          </div>
        )}
        <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:16}}>
          <div className="dr-card dr-fade-up-1">
            <div className="dr-card-header">
              <div className="dr-card-title">Today's Patients</div>
              {!loading&&rows.length>0&&<span style={{fontSize:11,padding:'4px 10px',borderRadius:20,background:'#E8F1FF',color:'#0A6EFF',fontWeight:700,textTransform:'uppercase'}}>{dept}</span>}
            </div>
            <div className="dr-card-body">
              {loading&&[1,2,3,4].map(n=>(
                <div key={n} style={{display:'flex',gap:12,padding:'12px 0',borderBottom:'1px solid var(--border)',opacity:.5}}>
                  <div style={{width:70,height:11,background:'var(--border)',borderRadius:6}}/>
                  <div style={{flex:1}}><div style={{height:12,background:'var(--border)',borderRadius:6,marginBottom:5,width:'55%'}}/><div style={{height:10,background:'var(--border)',borderRadius:6,width:'30%'}}/></div>
                </div>
              ))}
              {!loading&&rows.length===0&&<div style={{textAlign:'center',padding:'36px 20px',color:'var(--text-3)'}}><Ico name="users" size={36} color="var(--border)"/><div style={{marginTop:10,fontSize:13}}>No patients scheduled today.</div></div>}
              {!loading&&rows.length>0&&(
                <div style={{overflowX:'auto'}}>
                  <table className="dr-table"><thead><tr><th>ID</th><th>Patient</th><th>Time</th><th>Status</th></tr></thead>
                    <tbody>{rows.map((appt,i)=>(
                      <tr key={i} style={{cursor:'pointer',background:sel?.id===appt.id?'#F0F6FF':''}} onClick={()=>{if(rows[i].status==='paid')this.setState({selectedAppt:appointments[i]})}}>
                        <td><span style={{fontFamily:'monospace',fontWeight:700,color:'var(--brand)',fontSize:12}}>{appt.id}</span></td>
                        <td><div style={{fontWeight:600}}>{appt.patient}</div><div style={{fontSize:11,color:'var(--text-3)'}}>{appt.age} yrs</div></td>
                        <td style={{color:'var(--text-2)'}}>{appt.time}</td>
                        <td><StatusBadge status={appt.status}/></td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
          <div className="dr-card dr-fade-up-2">
            <div className="dr-card-header"><div className="dr-card-title">Next Patient</div></div>
            {loading?<div className="dr-next-patient" style={{opacity:.5}}><div className="dr-next-avatar" style={{background:'var(--border)'}}/></div>
            :sel?(
              <div className="dr-next-patient">
                <div className="dr-next-avatar"><Ico name="user" size={30} color="var(--brand)"/></div>
                <div className="dr-next-name">{sel.patient}</div>
                <div className="dr-next-sub">{sel.time} · {sel.dept}</div>
                {sel.gender!=='—'&&<div style={{fontSize:12,color:'var(--text-3)',marginBottom:6}}>{sel.gender} · {sel.blood} · {sel.age} yrs</div>}
                {sel.reason!=='—'&&<div style={{fontSize:12,color:'var(--text-2)',marginBottom:8,fontStyle:'italic'}}>"{sel.reason}"</div>}
                <span className="dr-next-badge"><StatusBadge status={sel.status}/></span>
                {sel.status==='paid'
                  ?<button className="dr-btn dr-btn-primary" onClick={()=>onNav&&onNav('prescribe',firstPaidAppt)}>Start Consultation</button>
                  :<div style={{marginTop:8,padding:'10px 14px',borderRadius:10,background:'#FFF0EB',border:'1px solid #fcd9c4',fontSize:12,color:'var(--warn)',textAlign:'center'}}>Payment pending</div>}
              </div>
            ):<div className="dr-next-patient"><div style={{textAlign:'center',color:'var(--text-3)',fontSize:13}}>No patient selected</div></div>}
          </div>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   APPOINTMENTS PAGE
════════════════════════════════════════════════════════════ */
class AppointmentsPage extends Component {
  constructor(props) {
    super(props);
    this.state={appointments:[],loading:true,error:null,search:'',filter:'all'};
  }
  componentDidMount(){this.fetchAppointments();this._timer=setInterval(()=>this.fetchAppointments(true),60000);}
  componentWillUnmount(){clearInterval(this._timer);}
  async fetchAppointments(silent=false){
    if(!silent)this.setState({loading:true,error:null});
    try{
      const u=JSON.parse(localStorage.getItem('dg_user')||'{}');
      const res=await postRequest(API_ENDPOINTS.ALL_DOCTOR_LIST,{DoctorID:u.personId||u.doctorId||null});
      const data=await res.json();
      let rows=[];
      if(data.status&&Array.isArray(data.data)&&Array.isArray(data.data[0]))rows=data.data[0];
      else if(Array.isArray(data.data))rows=data.data;
      else if(Array.isArray(data))rows=data;
      this.setState({appointments:rows,loading:false});
    }catch(err){this.setState({appointments:APPOINTMENTS,loading:false,error:err.message});}
  }
  mapRow(a,i){
    const name=`${a.PatientFirstName||''} ${a.PatientLastName||''}`.trim()||a.patient||`Patient ${i+1}`;
    const dob=a.PatientDOB||a.DOB||'';
    const age=dob?Math.floor((Date.now()-new Date(dob).getTime())/(1000*60*60*24*365.25)):(a.age||'—');
    return {
      id:String(a.AppointmentID||a.id||`APT-${2400+i}`),patient:name,age,
      dept:a.DepartmentName||a.dept||'—',time:a.Time||a.AppointmentTime||a.time||'—',
      status:(a.PaymentStatus||a.payStatus||'pending').toLowerCase(),reason:a.Reason||'—',spec:a.Specilization||'',
    };
  }
  render(){
    const{appointments,loading,error,search,filter}=this.state;
    const allRows=appointments.map((a,i)=>this.mapRow(a,i));
    const rows=allRows.filter(a=>{
      const q=search.toLowerCase();
      return(!q||a.patient.toLowerCase().includes(q)||a.id.toLowerCase().includes(q)||a.dept.toLowerCase().includes(q))&&(filter==='all'||a.status===filter);
    });
    return(
      <div>
        <div className="dr-page-header dr-fade-up" style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12}}>
          <div><h1 className="dr-page-title">Appointments</h1><p className="dr-page-sub">{loading?'Loading…':`${allRows.length} patients today`}</p></div>
          <button onClick={()=>this.fetchAppointments()} style={{border:'1.5px solid var(--border)',background:'transparent',borderRadius:10,padding:'7px 14px',fontSize:12,fontWeight:600,cursor:'pointer',color:'var(--text-2)',fontFamily:'var(--font-body)'}}>↺ Refresh</button>
        </div>
        {error&&!loading&&<div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:10,padding:'10px 14px',marginBottom:14,fontSize:13,color:'#FF6B35',display:'flex',gap:8}}><Ico name="alert" size={14} color="#FF6B35"/> Could not load from API.</div>}
        <div className="dr-card dr-fade-up" style={{marginBottom:16,padding:14}}>
          <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap'}}>
            <div style={{flex:1,minWidth:200,position:'relative',display:'flex',alignItems:'center'}}>
              <Ico name="search" size={15} color="var(--text-3)" style={{position:'absolute',left:12}}/>
              <input value={search} onChange={e=>this.setState({search:e.target.value})} placeholder="Search patient or ID…"
                style={{width:'100%',height:42,paddingLeft:38,paddingRight:14,border:'1.5px solid var(--border)',borderRadius:10,fontSize:13,fontFamily:'var(--font-body)',outline:'none'}}
                onFocus={e=>e.target.style.borderColor='var(--brand)'} onBlur={e=>e.target.style.borderColor='var(--border)'}/>
            </div>
            <div style={{display:'flex',gap:6}}>
              {['all','paid','pending'].map(f=>(
                <button key={f} onClick={()=>this.setState({filter:f})}
                  style={{padding:'8px 16px',borderRadius:8,border:'1.5px solid',borderColor:filter===f?'var(--brand)':'var(--border)',background:filter===f?'var(--brand-light)':'transparent',color:filter===f?'var(--brand)':'var(--text-2)',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'var(--font-body)',textTransform:'capitalize'}}>
                  {f==='all'?'All':f.charAt(0).toUpperCase()+f.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="dr-card dr-fade-up-1">
          {loading&&<div style={{padding:'0 4px'}}>{[1,2,3,4,5].map(n=><div key={n} style={{display:'flex',gap:14,padding:'14px 16px',borderBottom:'1px solid var(--border)',opacity:.5}}><div style={{width:72,height:11,background:'var(--border)',borderRadius:6}}/><div style={{flex:1}}><div style={{height:12,background:'var(--border)',borderRadius:6,marginBottom:5,width:'45%'}}/></div></div>)}</div>}
          {!loading&&rows.length===0&&<div style={{textAlign:'center',padding:'44px 20px',color:'var(--text-3)'}}><Ico name="users" size={36} color="var(--border)"/><div style={{marginTop:10,fontSize:13}}>{search||filter!=='all'?'No patients match your filter.':'No appointments today.'}</div></div>}
          {!loading&&rows.length>0&&(
            <div style={{overflowX:'auto'}}>
              <table className="dr-table">
                <thead><tr><th>ID</th><th>Patient</th><th>Department</th><th>Time</th><th>Status</th><th>Action</th><th>QR</th></tr></thead>
                <tbody>{rows.map((appt,i)=>(
                  <tr key={i}>
                    <td><span style={{fontFamily:'monospace',fontWeight:700,color:'var(--brand)',fontSize:12}}>{appt.id}</span></td>
                    <td><div style={{fontWeight:600}}>{appt.patient}</div><div style={{fontSize:11,color:'var(--text-3)'}}>{appt.age} yrs</div></td>
                    <td style={{color:'var(--text-2)'}}><div>{appt.dept}</div>{appt.spec&&<div style={{fontSize:11,color:'var(--text-3)'}}>{appt.spec}</div>}</td>
                    <td style={{color:'var(--text-2)'}}>{appt.time}</td>
                    <td><StatusBadge status={appt.status}/></td>
                    <td><button className="dr-btn dr-btn-ghost" onClick={()=>this.props.onNav&&this.props.onNav('prescribe',this.state.appointments[i])}>Prescribe →</button></td>
                    <td><button className="dr-btn dr-btn-ghost" style={{color:'var(--purple)',borderColor:'var(--purple)',fontSize:12}} onClick={()=>window.open(`${window.location.origin}/scan?id=${appt.id}`,'_blank')}>🔍 View QR</button></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   PRESCRIPTION PAGE — with Manual / Auto mode
════════════════════════════════════════════════════════════ */
class PrescribePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // mode
      medMode:  'manual',  // 'manual' | 'auto'
      labMode:  'manual',
      // manual editors
      medicines: [{ name:'', dosage:'', freq:'', dur:'', instr:'', notes:'' }],
      tests:     [{ name:'', dept:'', priority:'Normal', sample:'', notes:'' }],
      // auto selections
      selectedMeds: [],
      selectedLabs: [],
      // fetch state
      saved:false, saveLoading:false, saveError:null,
      prescriptionId:null, labTestId:null,
      medText:'', labText:'', rxLoading:true,
      patientData: null,
      // lab masters from API
      labMasters: [], labMastersLoading: false,
      // medicine masters from API
      medicineMasters: [], medicineMastersLoading: false,
    };
  }

  componentDidMount() {
    this.fetchExisting();
    this.fetchLabMasters();
  }

  async fetchLabMasters() {
    this.setState({ labMastersLoading: true, medicineMastersLoading: true });
    try {
      const res  = await getRequest(API_ENDPOINTS.LAB_MASTERS);
      const data = await res.json();
      console.log('Masters response:', JSON.stringify(data).slice(0, 400));

      const labRows = Array.isArray(data.data?.Doctor) ? data.data.Doctor : [];
      const medRows = Array.isArray(data.medicine?.medicine) ? data.medicine.medicine : [];

      console.log('Lab tests:', labRows.length, '| Medicines:', medRows.length);
      this.setState({
        labMasters: labRows, labMastersLoading: false,
        medicineMasters: medRows, medicineMastersLoading: false,
      });
    } catch(err) {
      console.warn('fetchLabMasters error:', err.message);
      this.setState({ labMastersLoading: false, medicineMastersLoading: false });
    }
  }

  async fetchExisting() {
    const raw = this.props.patient;
    const apptId = raw?.AppointmentID || raw?.id;
    if (apptId && !raw?.PatientFirstName) {
      try {
        const pRes  = await postRequest(API_ENDPOINTS.QR_VERIFY, { AppointmentID: String(apptId) });
        const pData = await pRes.json();
        let fp = null;
        if (pData.status && Array.isArray(pData.data?.[0])) fp = pData.data[0][0];
        else if (Array.isArray(pData.data)) fp = pData.data[0];
        else if (pData.data) fp = pData.data;
        if (fp) this.setState({ patientData: { ...fp, AppointmentID: apptId } });
      } catch(_) {}
    }
    const pat = this.getPatient();
    if (!pat || pat.id === '—') { this.setState({ rxLoading: false }); return; }
    try {
      const [rxRes, labRes] = await Promise.all([
        postRequest(API_ENDPOINTS.GET_PRESCRIPTION, { AppointmentID: pat.id }),
        postRequest(API_ENDPOINTS.GET_LAB_RESULTS,  { AppointmentID: pat.id }),
      ]);
      const [rxData, labData] = await Promise.all([rxRes.json(), labRes.json()]);
      let rx = null, lab = null;
      if (rxData.status && Array.isArray(rxData.data?.[0])) rx = rxData.data[0][0] || null;
      else if (Array.isArray(rxData.data)) rx = rxData.data[0] || null;
      if (labData.status && Array.isArray(labData.data?.[0])) lab = labData.data[0][0] || null;
      else if (Array.isArray(labData.data)) lab = labData.data[0] || null;
      const toHtml = t => {
        if (!t) return '';
        return t.replace(/\\n/g,'\n').replace(/\\r/g,'').replace(/\r\n|\r/g,'\n')
          .split('\n').map(l=>l.trim()).filter(Boolean).map(l=>'<p>'+l+'</p>').join('');
      };
      this.setState({
        rxLoading:false,
        prescriptionId: rx?.PrescriptionID||rx?.prescriptionId||null,
        labTestId:      lab?.LABTID||lab?.labTestId||null,
        medText:        toHtml(rx?.Medicines_details||rx?.Medicines||''),
        labText:        toHtml(lab?.Lab_test_details||lab?.LabTests||''),
      });
    } catch(err) { this.setState({ rxLoading:false }); }
  }

  updateMed(i,k,v) { const m=[...this.state.medicines];m[i]={...m[i],[k]:v};this.setState({medicines:m}); }
  updateTest(i,k,v){ const t=[...this.state.tests];t[i]={...t[i],[k]:v};this.setState({tests:t}); }

  getPatient() {
    const raw = this.state.patientData || this.props.patient;
    if (!raw) return null;
    const fn=raw.PatientFirstName||raw.patient?.split(' ')[0]||'';
    const ln=raw.PatientLastName||raw.patient?.split(' ')[1]||'';
    const name=`${fn} ${ln}`.trim()||raw.patient||'Patient';
    const dob=raw.PatientDOB||raw.DOB||'';
    const age=dob?Math.floor((Date.now()-new Date(dob).getTime())/(1000*60*60*24*365.25)):(raw.age||'—');
    return {
      id:String(raw.AppointmentID||raw.id||'—'), patient:name, age,
      dept:raw.DepartmentName||raw.dept||'—', time:raw.Time||raw.AppointmentTime||raw.time||'—',
      status:(raw.PaymentStatus||raw.payStatus||'pending').toLowerCase(),
      reason:raw.Reason||raw.ReasonForVisit||'—', gender:raw.PatientGender||'—', blood:raw.PatientBloodGroup||'—', spec:raw.Specilization||'',
    };
  }

  buildMedText() {
    const { medMode, medicines, selectedMeds } = this.state;
    if (medMode === 'auto') return selectedMeds.join('\n');
    const stripHtml = h => {
      if (!h) return '';
      return h.replace(/<br\s*\/?>/gi,'\n').replace(/<\/p>/gi,'\n').replace(/<\/li>/gi,'\n')
        .replace(/<[^>]+>/g,'').replace(/&nbsp;/g,' ').replace(/\n\n+/g,'\n').trim();
    };
    return stripHtml(medicines[0]?.name||'');
  }

  buildLabText() {
    const { labMode, tests, selectedLabs } = this.state;
    if (labMode === 'auto') return selectedLabs.join('\n');
    const stripHtml = h => {
      if (!h) return '';
      return h.replace(/<br\s*\/?>/gi,'\n').replace(/<\/p>/gi,'\n').replace(/<\/li>/gi,'\n')
        .replace(/<[^>]+>/g,'').replace(/&nbsp;/g,' ').replace(/\n\n+/g,'\n').trim();
    };
    return stripHtml(tests[0]?.name||'');
  }

  async save() {
    const pat = this.getPatient();
    if (!pat) { this.setState({ saveError:'No patient selected.' }); return; }
    const u=JSON.parse(localStorage.getItem('dg_user')||'{}');
    const { prescriptionId, labTestId } = this.state;
    const payload = {
      AppointmentID:  parseInt(pat.id),
      Medicines:      this.buildMedText(),
      LabTests:       this.buildLabText(),
      DoctorID:       u.personId||null,
      PrescriptionID: prescriptionId||'',
      LABTID:         labTestId||'',
    };
    console.log('Save Prescription payload:', payload);
    this.setState({ saveLoading:true, saveError:null, saved:false });
    try {
      const res=await postRequest(API_ENDPOINTS.SAVE_PRESCRIPTION, payload);
      const data=await res.json();
      console.log('Save response:', data);
      this.setState({ saveLoading:false, saved:true });
      setTimeout(()=>{ if(this.props.onNav)this.props.onNav('appointments'); }, 1500);
    } catch(err) { this.setState({ saveLoading:false, saveError:err.message }); }
  }

  render() {
    const { medMode, labMode, medicines, tests, selectedMeds, selectedLabs, saved, rxLoading, medText, labText, saveError, saveLoading, labMasters, labMastersLoading } = this.state;
    const pat = this.getPatient();

    return (
      <div>
        <div className="dr-page-header dr-fade-up">
          <h1 className="dr-page-title">Write Prescription</h1>
          <p className="dr-page-sub">Add medicines and lab tests to patient's Smart QR</p>
        </div>

        {/* Patient info */}
        {!pat ? (
          <div className="dr-rx-patient-wrap dr-fade-up" style={{background:'#FFF0EB',border:'1px solid #fcd9c4'}}>
            <Ico name="alert" size={18} color="var(--warn)"/>
            <div style={{fontSize:13,color:'var(--warn)'}}>
              No patient selected. Go to <button onClick={()=>this.props.onNav&&this.props.onNav('appointments')} style={{border:'none',background:'none',color:'var(--brand)',fontWeight:700,cursor:'pointer',padding:0,fontSize:13}}>Appointments</button> and click Prescribe →
            </div>
          </div>
        ) : (
          <div className="dr-rx-patient-wrap dr-fade-up">
            <div className="dr-rx-doc-avatar"><Ico name="user" size={20} color="#fff"/></div>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,fontSize:15}}>{pat.patient}</div>
              <div style={{fontSize:12,color:'var(--text-2)',marginTop:2}}>
                <span style={{fontFamily:'monospace',fontWeight:700,color:'var(--brand)'}}>Appt #{pat.id}</span>
                {' · '}{pat.age} yrs · {pat.gender} · {pat.blood} · {pat.dept} · {pat.time}
              </div>
              {pat.reason!=='—'&&<div style={{fontSize:11,color:'var(--text-3)',marginTop:2,fontStyle:'italic'}}>Reason: {pat.reason}</div>}
            </div>
            <StatusBadge status={pat.status}/>
          </div>
        )}

        {saved && (
          <div className="dr-alert dr-alert-success dr-fade-up">
            <Ico name="check" size={16} color="#059669"/>
            Prescription saved! Smart QR updated for {pat?.patient||'patient'}.
          </div>
        )}

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>

          {/* ══ MEDICINE PRESCRIPTION ══ */}
          <div className="dr-card dr-fade-up-1">
            <div className="dr-card-header">
              <div className="dr-card-title">💊 Medicine Prescription</div>
            </div>
            <div style={{padding:16}}>
              <ModeToggle mode={medMode} onChange={m=>this.setState({medMode:m})} />
              {rxLoading ? (
                <div style={{textAlign:'center',padding:'32px 0',color:'var(--text-3)',fontSize:13}}>Loading…</div>
              ) : medMode === 'manual' ? (
                <QuillEditor
                  value={medicines[0]?.name || medText}
                  onChange={val=>this.updateMed(0,'name',val)}
                  placeholder="e.g.&#10;1. Paracetamol 500mg — Twice daily — After food — 5 days"
                  accentColor="#0A6EFF"
                />
              ) : (
                <div>
                  {this.state.medicineMastersLoading && (
                    <div style={{textAlign:'center',padding:'16px 0',color:'var(--text-3)',fontSize:13}}>Loading medicines…</div>
                  )}
                  {!this.state.medicineMastersLoading && (
                    <AutoSelect
                      selected={selectedMeds}
                      options={(() => {
                        const masters = this.state.medicineMasters;
                        if (!masters || masters.length === 0) return MEDICINE_OPTIONS;
                        const mapped = masters
                          .filter(m => !m.Status || (m.Status||'').toLowerCase() === 'active')
                          .map(m => m.Medicine_Name || m.MedicineName || m.medicine_name || m.name || m.Name || '')
                          .filter(Boolean);
                        console.log('Medicine options from API:', mapped.length, mapped[0]);
                        return mapped.length > 0 ? mapped : MEDICINE_OPTIONS;
                      })()}
                      placeholder="Search medicines…"
                      onChange={v=>this.setState({selectedMeds:v})}
                    />
                  )}
                  {selectedMeds.length > 0 && (
                    <div style={{marginTop:12,background:'#F8FAFC',borderRadius:10,padding:'12px 14px',fontSize:12,color:'var(--text-2)',lineHeight:2}}>
                      <div style={{fontWeight:700,color:'var(--text-1)',marginBottom:6,fontSize:13}}>Selected ({selectedMeds.length}):</div>
                      {selectedMeds.map((m,i)=><div key={i} style={{padding:'2px 0',borderBottom:'1px solid #E2E8F0'}}>• {m}</div>)}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* ══ LAB TEST ORDERS ══ */}
          <div className="dr-card dr-fade-up-2">
            <div className="dr-card-header">
              <div className="dr-card-title">🔬 Lab Test Orders</div>
            </div>
            <div style={{padding:16}}>
              <ModeToggle mode={labMode} onChange={m=>this.setState({labMode:m})} />
              {rxLoading ? (
                <div style={{textAlign:'center',padding:'32px 0',color:'var(--text-3)',fontSize:13}}>Loading…</div>
              ) : labMode === 'manual' ? (
                <QuillEditor
                  value={tests[0]?.name || labText}
                  onChange={val=>this.updateTest(0,'name',val)}
                  placeholder="e.g.&#10;1. CBC — Haematology — Blood sample"
                  accentColor="#7B5CF6"
                />
              ) : (
                <div>
                  {this.state.labMastersLoading && (
                    <div style={{textAlign:'center',padding:'16px 0',color:'var(--text-3)',fontSize:13}}>Loading lab tests…</div>
                  )}
                  {!this.state.labMastersLoading && (
                    <AutoSelect
                      selected={selectedLabs}
                      options={(() => {
                        const masters = this.state.labMasters;
                        if (!masters || masters.length === 0) return LAB_OPTIONS;
                        const mapped = masters
                          .filter(m => !m.Status || (m.Status||'').toLowerCase() === 'active')
                          .map(m => {
                            return m.Test_Name || m.TestName || m.test_name || m.name || m.Name || '';
                          })
                          .filter(Boolean);
                        console.log('Mapped lab options:', mapped.length, mapped[0]);
                        return mapped.length > 0 ? mapped : LAB_OPTIONS;
                      })()}
                      placeholder="Search lab tests…"
                      onChange={v=>this.setState({selectedLabs:v})}
                    />
                  )}
                  {selectedLabs.length > 0 && (
                    <div style={{marginTop:12,background:'#F8FAFC',borderRadius:10,padding:'12px 14px',fontSize:12,color:'var(--text-2)',lineHeight:2}}>
                      <div style={{fontWeight:700,color:'var(--text-1)',marginBottom:6,fontSize:13}}>Selected ({selectedLabs.length}):</div>
                      {selectedLabs.map((l,i)=><div key={i} style={{padding:'2px 0',borderBottom:'1px solid #E2E8F0'}}>• {l}</div>)}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {saveError && (
          <div style={{background:'#FFF0EB',border:'1px solid #fcd9c4',borderRadius:10,padding:'10px 16px',marginBottom:12,fontSize:13,color:'var(--warn)',display:'flex',gap:8}}>
            <Ico name="alert" size={14} color="var(--warn)"/> Save failed: {saveError}
          </div>
        )}
        <div style={{textAlign:'right'}}>
          <button className="dr-btn dr-btn-primary"
            style={{width:'auto',padding:'12px 28px',borderRadius:12,fontSize:14,opacity:saveLoading?.7:1}}
            onClick={()=>this.save()} disabled={saveLoading}>
            {saveLoading?<><Ico name="qr" size={16} color="#fff"/> Saving…</>:<><Ico name="qr" size={16} color="#fff"/> Save &amp; Update Smart QR</>}
          </button>
        </div>
      </div>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   BOTTOM NAV
════════════════════════════════════════════════════════════ */
class BottomNav extends Component {
  render() {
    const{activePage,onNav}=this.props;
    const ITEMS=[
      {id:'dashboard',   label:'Home',    icon:'home'},
      {id:'appointments',label:'Patients',icon:'calendar'},
      {id:'prescribe',   label:'Rx',      icon:'pill'},
      {id:'scan-qr',     label:'Scan QR', icon:'qr'},
    ];
    return(
      <nav className="dr-bottom-nav">
        {ITEMS.map(item=>(
          <button key={item.id} className={`dr-bottom-btn${activePage===item.id?' active':''}`} onClick={()=>onNav(item.id)}>
            <Ico name={item.icon} size={20} color={activePage===item.id?'var(--brand)':'var(--text-3)'}/>
            {item.label}
          </button>
        ))}
      </nav>
    );
  }
}

/* ════════════════════════════════════════════════════════════
   PAGE META
════════════════════════════════════════════════════════════ */
const PAGE_META = {
  'dashboard':    { title:'Doctor Dashboard',   subtitle:"Today's consultations"   },
  'appointments': { title:'Appointments',       subtitle:'All patients for today'  },
  'prescribe':    { title:'Write Prescription', subtitle:'Update patient Smart QR' },
  'scan-qr':      { title:'Scan QR',            subtitle:'Scan patient QR code'    },
};

/* ════════════════════════════════════════════════════════════
   DOCTOR DASHBOARD ROOT
════════════════════════════════════════════════════════════ */
export class DoctorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { activePage:'appointments', sidebarOpen:false, selectedPatient:null };
  }
  componentDidMount() {
    const apptId = localStorage.getItem('dg_prescribe_apptId');
    if (apptId) {
      localStorage.removeItem('dg_prescribe_apptId');
      this.setState({ activePage:'prescribe', selectedPatient:{ AppointmentID: apptId } });
    }
  }
  setPage(page, patient=null) {
    if (page==='scan-qr') { window.open(window.location.origin+'/scan','_blank'); this.setState({sidebarOpen:false}); return; }
    this.setState({ activePage:page, sidebarOpen:false, selectedPatient:patient||this.state.selectedPatient });
  }
  toggleSidebar(){this.setState(s=>({sidebarOpen:!s.sidebarOpen}));}
  renderPage(){
    const{activePage,selectedPatient}=this.state;
    const{user}=this.props;
    const doctorName=user?.name||'Doctor';
    switch(activePage){
      case 'dashboard':    return <DoctorDashboardPage doctorName={doctorName} onNav={(p,pat)=>this.setPage(p,pat)}/>;
      case 'appointments': return <AppointmentsPage onNav={(p,pat)=>this.setPage(p,pat)}/>;
      case 'prescribe':    return <PrescribePage patient={selectedPatient} onNav={p=>this.setPage(p)}/>;
      default:             return <AppointmentsPage onNav={(p,pat)=>this.setPage(p,pat)}/>;
    }
  }
  render(){
    const{activePage,sidebarOpen}=this.state;
    const{user,onLogout}=this.props;
    const meta=PAGE_META[activePage]||PAGE_META['appointments'];
    return(
      <div className="dr-shell">
        <Sidebar activePage={activePage} onNav={p=>this.setPage(p)} isOpen={sidebarOpen} onClose={()=>this.setState({sidebarOpen:false})} onLogout={onLogout} doctorName={user?.name||'Doctor'}/>
        <div className="dr-main">
          <Header title={meta.title} subtitle={meta.subtitle} onMenuClick={()=>this.toggleSidebar()}/>
          <main className="dr-content">{this.renderPage()}</main>
        </div>
        <BottomNav activePage={activePage} onNav={p=>this.setPage(p)}/>
      </div>
    );
  }
}

export default DoctorDashboard;